import _classCallCheck from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
import { Layer } from './topology';
import { RandomSeed } from '../backend/random_seed';
var BaseRandomLayer = /*#__PURE__*/function (_Layer) {
  _inherits(BaseRandomLayer, _Layer);
  function BaseRandomLayer(args) {
    var _this;
    _classCallCheck(this, BaseRandomLayer);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseRandomLayer).call(this, args));
    _this.randomGenerator = new RandomSeed(args.seed);
    return _this;
  }
  _createClass(BaseRandomLayer, [{
    key: "getConfig",
    value: function getConfig() {
      var config = {
        'seed': this.randomGenerator.seed
      };
      var baseConfig = _get(_getPrototypeOf(BaseRandomLayer.prototype), "getConfig", this).call(this);
      Object.assign(config, baseConfig);
      return config;
    }
  }]);
  return BaseRandomLayer;
}(Layer); // A layer handle the random number creation and savemodel behavior.
/** @nocollapse */
BaseRandomLayer.className = 'BaseRandomLayer';
export { BaseRandomLayer };